<template>
  <h3 class="h3">Führst du das Fahrsicherheitstraining auf freiwilliger Basis durch?</h3>
  <RadioMenu v-model="preInterestRadio" :options="options"/>
  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import RadioMenu from '../../components/RadioMenu.vue'
import { computed } from 'vue';
import { DetailStep, VorauswahlFreiwillig, Navigation } from '../../models/enums'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';

const options = Object.values(VorauswahlFreiwillig);
const store = useStore();
const nextDisabled = computed(() => store.state.preInterestFreiwillig == null);

const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  store.commit("updateStep", DetailStep.FAHRZEUGTYP);
  scrollToTop();
}
const preInterestRadio = computed({
  get: () => store.state.preInterestFreiwillig,
  set: value => store.commit("updatePreInterestFreiwillig", value)
});
</script>